module.exports = __webpack_public_path__ + "static/img/s6.39f2cb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/s6.png
// module id = ijGy
// module chunks = 0